export default {
	data() {
		return {
			moduleName: 'dashboardCarousels',
			entityName: 'dashboard_carousel',
			detailPageRouteName: 'dashboardCarouselDetail',
			entity: {
				id: null,
				name: "",
				id_operator: 0,
				id_subscriber: null,
				id_subscriber_profile: null,
				show_variant: 'PORTRAIT',
				dashboard_items_count: 12,
				services: [],
				id_tags: [],
				id_formats: [],
				id_contents: [],
				id_countries: [],
				id_channels: [],
				id_broadcasts: [],
				id_shows: [],
				rating: {value_from: 0, value_to: 100},
				year: {value_from: 1900, value_to: null},
				type: 'custom',
				id_thematic_channel_group: null,
				id_channel_group: null,
				minimal_broadcast_length_minutes: null,
				days_back: null,
				is_default: false,
				is_visible: true,
				default_weight: null
			},
			updateFields: [
				'name',
				'id_operator',
				'id_subscriber_profile',
				'id_subscriber',
				'show_variant',
				'dashboard_items_count',
				'services',
				'id_shows',
				'id_broadcasts',
				'id_tags',
				'id_countries',
				'id_channels',
				'rating',
				'year',
				'type',
				'subtype',
				'id_thematic_channel_group',
				'id_channel_group',
				'minimal_broadcast_length_minutes',
				'days_back',
				'is_default',
				'is_visible',
				'default_weight',
			],
		};
	},
	computed:{
		redirectParams(){
			return this.isSubscriber
				? {path: 'subscriberDetail', params: {id: this.$route.params.idSubscriber}}
				: {path: 'dashboardCarousels', params: {}}
		},
		isSubscriber(){
			return this.$route.params.idSubscriber !== undefined;
		},
		idSubscriber(){
			return this.$route.params.idSubscriber;
		}
	},
	methods: {
		_processDetailErrorMessage(error) {
			return this.processErrorMessage(error);
		},
		processErrorMessage(error) {
			this._.forEach(error['validation_errors'], function (errorMessage) {
				error['error_message'] = errorMessage;
			});
			return error['error_message'];
		},
		_beforeCreateEntityActions(params = null) {
			params.id_subscriber = this.$route.params.idSubscriber ? this.$route.params.idSubscriber : null;
			params.id_operator = this.$_loggedUser_isOperator ? this.$_loggedUser_operatorId : params.id_operator;
			return params
		},
	}
};



// WEBPACK FOOTER //
// ./src/components/views/dashboardCarousels/mixins/dashboardCarousel.js